<div class="footer-container">
  &nbsp;
</div>
